import { action, computed, observable } from 'mobx';

export declare interface ICameraStore {
  image: Blob | null;
  videoIsRunning: boolean;
  photoIsTaken: boolean;
  startVideo: (video: HTMLVideoElement) => void;
  stopVideo: (video: HTMLVideoElement) => void;
  takePhoto: (video: HTMLVideoElement, canvas: HTMLCanvasElement) => void;
  dropPhoto: () => void;
  acceptPhoto: () => void;
}

export class CameraStore implements ICameraStore {

  @observable private _videoIsRunning : boolean = false;
  @observable private _photoIsTaken: boolean = false;
  @observable private _image: Blob | null = null;

  @computed get videoIsRunning() {
    return this._videoIsRunning;
  }

  @computed get photoIsTaken() {
    return this._photoIsTaken;
  }

  @computed get image() {
    return this._image;
  }

  @action public startVideo(video: HTMLVideoElement) {
    this.stopVideo(video);
    navigator.mediaDevices
      .getUserMedia({audio: false, video: {facingMode: 'environment'}})
      .then((stream) => {
        video.srcObject = stream;
        this._videoIsRunning = true;
      });
  }

  @action public stopVideo(video: HTMLVideoElement) {
    this._videoIsRunning = false;
    if (video && video.srcObject) {
      const stream = video.srcObject as MediaStream;
      stream
        .getTracks()
        .forEach(track => track.stop());
      video.srcObject = null;
    }
  }

  @action public takePhoto(video: HTMLVideoElement, canvas: HTMLCanvasElement) {
    if (this._videoIsRunning) {
      this.dropPhoto();
      if (video && canvas && video.srcObject) {
        const context = canvas.getContext('2d');
        if (context) {
          canvas.height = (video.videoHeight / video.videoWidth) * canvas.width
          context.drawImage(
            video,
            0,
            0,
            canvas.width,
            canvas.height
          );
          canvas.toBlob((blob) => {
            this._image = blob;
          })
          this._photoIsTaken = true;
          this._videoIsRunning = false;
        }
      }
    }
  }

  @action public dropPhoto() {
    this._photoIsTaken = false;
    this._videoIsRunning = true;
    this._image = null;
  }

  @action public acceptPhoto() {
    this._photoIsTaken = false;
    this._videoIsRunning = true;
  }

}



// WEBPACK FOOTER //
// ./src/components/camera/CameraStore.ts